import React from 'react';
import PropTypes from 'prop-types';

import LoaderComponent from './loader.style';

const Loader = ({ overlay }) => (
  <LoaderComponent overlay={overlay}>
    <svg className="isoContentLoader" viewBox="0 0 50 50">
      <circle
        className="isoContentLoaderCircle"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth="3.6"
      />
    </svg>
  </LoaderComponent>
);

Loader.propTypes = {
  overlay: PropTypes.bool
};

Loader.defaultProps = {
  overlay: false
};

export default Loader;
